import React from "react";
import PropTypes from "prop-types";

import LineSeries from "./LineSeries";
import AreaOnlySeries from "./AreaOnlySeries";
import { strokeDashTypes } from "../utils";

function AreaSeries(props) {
  const { yAccessor, baseAt } = props;
  const {
    className,
    opacity,
    stroke,
    fill,
    interpolation,
    style,
    canvasClip,
    canvasGradient,
  } = props;

  // Destructure stroke object
  const strokeColor = stroke?.color || "#009CFe";
  const strokeOpacity = stroke?.opacity ?? 1;
  const strokeWidth = stroke?.width ?? 2;
  const strokeDasharray = stroke?.dash ?? "Solid";

  return (
    <g className={className}>
      <AreaOnlySeries
        yAccessor={yAccessor}
        interpolation={interpolation}
        base={baseAt}
        canvasGradient={canvasGradient}
        fill={fill}
        opacity={opacity}
        style={style}
        canvasClip={canvasClip}
        stroke="none"
      />
      <LineSeries
        yAccessor={yAccessor}
        stroke={{
          color: strokeColor,
          opacity: strokeOpacity,
          width: strokeWidth,
          dash: strokeDasharray,
        }}
        strokeWidth={strokeWidth}
        strokeOpacity={strokeOpacity}
        strokeDasharray={strokeDasharray}
        interpolation={interpolation}
        style={style}
        canvasClip={canvasClip}
        fill="none"
        highlightOnHover={false}
      />
    </g>
  );
}

AreaSeries.propTypes = {
  stroke: PropTypes.shape({
    color: PropTypes.string,
    opacity: PropTypes.number,
    width: PropTypes.number,
    dash: PropTypes.oneOf(strokeDashTypes),
  }),
  strokeWidth: PropTypes.number,
  canvasGradient: PropTypes.func,
  fill: PropTypes.string.isRequired,
  opacity: PropTypes.number.isRequired,
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  baseAt: PropTypes.func,
  interpolation: PropTypes.func,
  canvasClip: PropTypes.func,
  style: PropTypes.object,
};

AreaSeries.defaultProps = {
  stroke: {
    color: "#4682B4",
    opacity: 1,
    width: 1,
    dash: "Solid",
  },
  opacity: 0.5,
  fill: "#4682B4",
  className: "react-stockcharts-area",
};

export default AreaSeries;
